const mutations = {

}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/users/mutations/index.js